import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ConfirmDialog } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useDeleteContact } from './useDeleteContact';
export function DeleteContact(props) {
    const { id, onClose } = props;
    const [mutate, state] = useDeleteContact(onClose);
    return (<ConfirmDialog loading={state.loading} title={t({
            message: 'Delete contact',
            comment: 'Contact library - Delete contact confirm dialog title',
        })} icon={<Falcon icon="trash-can"/>} appearance="danger" size="sm" confirm={t({ message: 'Delete', comment: 'Contact library - Delete contact confirm dialog confirm button' })} cancel={t({ message: 'Cancel', comment: 'Contact library - Delete contact confirm dialog cancel button' })} onConfirm={() => mutate(id)} onCancel={onClose}>
      <Trans comment="Contact library - Delete contact confirm dialog message">
        Are you sure you want to delete this contact?
      </Trans>
    </ConfirmDialog>);
}
